export default "__VITE_ASSET__CupV0i0X__"